var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchiveWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-archive-restore",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 5,
    x: 2,
    y: 3,
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8v11a2 2 0 0 0 2 2h2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 8v11a2 2 0 0 1-2 2h-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m9 15 3-3 3 3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12v9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveWhite);
export default __webpack_public_path__ + "static/media/archive-white.2a478f3308d2e1aeda0a32c7089ba363.svg";
export { ForwardRef as ReactComponent };